import apiClient from '@/services/api_client_crm.js'

export const state = {
  profile: {}, // the user profile,
  account: {}, // the billing account
  products: {},
  apps: []
}

export const getters = {
  isAuthenticated: (state) => {
    return true
  },
  firstName: (state) => {
    return (typeof state.profile !== 'undefined' && typeof state.profile.first_name === 'string') ? state.profile.first_name : ''
  },
  lastName: (state) => {
    return (typeof state.profile !== 'undefined' && typeof state.profile.last_name === 'string') ? state.profile.last_name : ''
  },
  company: (state) => {
    return (typeof state.account !== 'undefined' && typeof state.account.company === 'string') ? state.account.company : ''
  },
  mobile: (state) => {
    return (state.profile === null || state.profile.mobile === null) ? '' : state.profile.mobile
  },
  email: (state) => {
    return (state.profile === null || state.profile.email === null) ? '' : state.profile.email
  },
  products: (state) => {
    return (state.products === null) ? [] : state.products
  },
  accountEnabled: (state) => {
    return (state.account === null) ? null : state.is_enabled
  },
  accountNumber: (state) => {
    return (state.account !== null && typeof state.account !== 'undefined' && typeof state.account.account_number !== 'undefined') ? state.account.account_number : ''
  },
  defaultApiKey: (state) => {
    const matches = state.apps.filter(app => app.is_default)
    if (matches.length > 0) {
      return matches[0].api_key
    } else if (state.apps.length > 0) {
      return state.apps[0].api_key
    }
  }
}

export const mutations = {
  LOAD_DATA (state, payload) {
    state.profile = payload.profile
    state.apps = payload.apps
    state.account = payload.account
    state.products = payload.products
  },
  UPDATE_USER (state, payload) {
    // Expects to receive the Profile object
    state.profile = payload
  },
  UPDATE_ACCOUNT (state, payload) {
    state.account = payload
  },
  UPDATE_PRODUCTS (state, payload) {
    state.products = payload
  },
  UPDATE_USER_ATTR (state, payload) {
    // Expects a tuple [key , val] to update a field value
    const [key, value] = payload
    if (key === 'company') {
      state.account[key] = value
    } else {
      state.profile[key] = value
    }
  },
  UPDATE_APP (state, updatedApp) {
    // expects to receive an App object
    state.apps = state.apps.map(obj => (obj.id === updatedApp.id) ? updatedApp : obj)
  },
  ADD_APP (state, newApp) {
    // expects to receive an App object
    console.log(newApp)
    state.apps.push(newApp)
  },
  DELETE_APP (state, deleteId) {
    // expects to receive the ID  of the app
    state.apps = state.apps.filter(obj => obj.id !== deleteId)
  }
}

export const actions = {
  loadProfile ({ state, commit, rootState }) {
    return apiClient
      .get('/api/profile')
      .then(response => {
        this.commit('LOAD_DATA', response.data)
      })
      .catch(err => {
        console.log(`Unable to retrieve data: ${err}`)
        return Promise.reject(err)
      })
  }
}
